/**
 * Was ein Werkzeug im Verlauf zeigt — die EINE Antwort für Server und Gerät. (15.10.2026, Plan „Karten zu 100 % einheitlich“)
 *
 * Bis heute entschieden drei Listen im Frontend „Karte, Zeile oder nichts“ (SILENT_TOOL_CARDS und BROWSER_STEP_TOOLS in
 * frontend/app.ts, SCHRITT_WERKZEUGE in frontend/lib/schritte.ts) — keine hing am Werkzeugregister, und ein neues
 * Werkzeug war im Zweifel eine Karte. Jetzt steht die Politik je Werkzeug im Register (server/werkzeug-register-daten.ts,
 * Felder `karte` und `familie`) und kommt abgeleitet hierher (shared/karten-politik-daten.ts); die drei Listen sind nur
 * noch Abfragen darauf.
 *
 * ⚠️ Ein Name, den das Register nicht kennt (ein Ereignis wie `reminder_done`, ein alter Name im Verlauf), hat KEINE
 *    Politik (`undefined`). Das Gerät behandelt ihn wie bisher: eigene Karte, sonst eine leise Zeile — nie Rohdaten.
 */
import type { Familie, KartenPolitik } from "./karten-anzeige.js";
import { KARTEN_POLITIK_DATEN } from "./karten-politik-daten.js";

/** Die Politik eines Werkzeugs — `undefined`, wenn das Register es nicht kennt. */
export function politikVon(tool: string): KartenPolitik | undefined {
  return Object.hasOwn(KARTEN_POLITIK_DATEN, tool) ? KARTEN_POLITIK_DATEN[tool]?.karte : undefined;
}

/** Die Familie eines Werkzeugs — „sonst“, wenn das Register es nicht kennt. */
export function familieVon(tool: string): Familie {
  return (Object.hasOwn(KARTEN_POLITIK_DATEN, tool) ? KARTEN_POLITIK_DATEN[tool]?.familie : undefined) ?? "sonst";
}

/** Alle Werkzeuge mit dieser Politik (und, wenn angegeben, dieser Familie), nach Name sortiert. */
export function werkzeugeMitPolitik(politik: KartenPolitik, familie?: Familie): string[] {
  return Object.entries(KARTEN_POLITIK_DATEN)
    .filter(([, z]) => z.karte === politik && (familie === undefined || z.familie === familie))
    .map(([n]) => n)
    .sort();
}
